<ng-select
  [ngModel]="selectedOption || undefined"
  (ngModelChange)="onSelect($event)"
  [items]="options$ | async"
  [clearable]="false"
  [searchable]="true"
  [disabled]="disabled"
  [virtualScroll]="true"
></ng-select>
